import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
// Minimal coordinate presence
const CoordinateGrid = () => <div className="absolute inset-0 w-full h-full opacity-[0.015] pointer-events-none" style={{
  backgroundImage: 'linear-gradient(#F5F5F5 0.5px, transparent 0.5px), linear-gradient(90deg, #F5F5F5 0.5px, transparent 0.5px)',
  backgroundSize: '80px 80px'
}} aria-hidden="true" data-id="element-2013" />;
export function MirrorsLanding() {
  return <>
      <Helmet data-id="element-2014">
        <title data-id="element-2015">Mirrors — Continuous Interpretations | Lazy Monk Labs</title>
        <meta name="description" content="Mirrors are continuous interpretations. Observe how a pattern actually unfolds over time, across real situations." data-id="element-2016" />
        <meta name="robots" content="index, follow" data-id="element-2017" />
      </Helmet>

      <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5]" data-id="element-2018">
        {/* Navigation */}
        <header data-id="element-2019">
          <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0A]/95 backdrop-blur-sm border-b border-[#2B2B2B]" data-id="element-2020">
            <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-2021">
              <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity" data-id="element-2022">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jXd6KyuddrgAfqwwkkpUrR/Lazy_Monk_Labs_Logo.png" alt="Lazy Monk Labs Logo" className="h-8 w-auto" width="32" height="32" data-id="element-2023" />
                <span className="text-base font-mono tracking-tight text-gray-400" data-id="element-2024">
                  Lazy Monk Labs
                </span>
              </Link>
              <div className="flex items-center gap-8" data-id="element-2025">
                <Link to="/decodes" className="text-sm text-gray-500 hover:text-[#F5F5F5] transition-colors font-medium" data-id="element-2026">
                  Decodes
                </Link>
                <Link to="/mirrors/work" className="text-sm text-[#F5F5F5] hover:text-gray-400 transition-colors font-medium" data-id="element-2027">
                  Work Mirror
                </Link>
                <Link to="/decoder" className="text-sm text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono" data-id="element-2028">
                  Decoder
                </Link>
                <Link to="/careers" className="text-sm text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono" data-id="element-2029">
                  Careers
                </Link>
                <a href="https://wa.me/919633096997" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono" data-id="element-2030">
                  Contact
                </a>
              </div>
            </div>
          </nav>
        </header>

        <main className="pt-24 pb-16" data-id="element-2031">
          {/* 1. HERO */}
          <section className="relative py-32 md:py-40 px-6 overflow-hidden" data-id="element-2032">
            <CoordinateGrid data-id="element-2033" />
            <div className="relative z-10 max-w-5xl mx-auto space-y-12" data-id="element-2034">
              <div className="space-y-6" data-id="element-2035">
                <h1 className="text-5xl md:text-7xl font-serif leading-none text-[#F5F5F5]" style={{
                fontFamily: 'Georgia, serif'
              }} data-id="element-2036">
                  Mirrors are continuous interpretations.
                </h1>

                <p className="text-xl md:text-2xl text-gray-400 font-light leading-relaxed max-w-3xl" data-id="element-2037">
                  A Mirror lets you observe how a pattern actually unfolds over
                  time, across real situations — using the same engine that
                  powers all Decodes at Lazy Monk Labs.
                </p>
              </div>

              <div className="pt-8 flex flex-col sm:flex-row gap-4" data-id="element-2038">
                <Link to="/mirrors/work" className="px-10 py-4 bg-[#F5F5F5] text-[#0A0A0A] text-sm font-medium hover:bg-gray-200 transition-colors text-center" data-id="element-2039">
                  Explore Work Mirror
                </Link>
                <Link to="/decoder" className="px-10 py-4 border border-[#F5F5F5] text-[#F5F5F5] text-sm font-medium hover:bg-[#F5F5F5] hover:text-[#0A0A0A] transition-colors text-center" data-id="element-2040">
                  Learn about the engine (Decoder)
                </Link>
              </div>
            </div>
          </section>

          {/* 2. WHAT IS A MIRROR */}
          <section className="py-24 px-6 border-t border-[#2B2B2B]" data-id="element-2041">
            <div className="max-w-4xl mx-auto" data-id="element-2042">
              <h2 className="text-3xl md:text-4xl font-serif text-[#F5F5F5] mb-12" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-2043">
                What is a Mirror?
              </h2>

              <div className="space-y-8 text-lg text-gray-400 leading-relaxed" data-id="element-2044">
                <p data-id="element-2045">
                  A Mirror is not a report. And not a one-time interpretation.
                </p>

                <p data-id="element-2046">
                  A Mirror is a living system that continuously interprets your
                  underlying pattern as it shows up in real life.
                </p>

                <div className="pt-6 border-t border-[#2B2B2B] space-y-6" data-id="element-2047">
                  <p className="text-gray-500" data-id="element-2048">Instead of asking:</p>
                  <p className="pl-6 border-l-2 border-[#2B2B2B]" data-id="element-2049">
                    "What is my pattern?"
                  </p>

                  <p className="text-gray-500 pt-4" data-id="element-2050">A Mirror lets you watch:</p>
                  <p className="pl-6 border-l-2 border-[#2B2B2B] text-[#F5F5F5]" data-id="element-2051">
                    "How does this pattern keep playing out?"
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* 3. WHAT MIRRORS ARE FOR */}
          <section className="py-24 px-6 bg-[#111214] border-t border-[#2B2B2B]" data-id="element-2052">
            <div className="max-w-4xl mx-auto" data-id="element-2053">
              <h2 className="text-3xl md:text-4xl font-serif text-[#F5F5F5] mb-12" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-2054">
                When do people use a Mirror?
              </h2>

              <div className="space-y-6 text-base text-gray-400" data-id="element-2055">
                <p data-id="element-2056">• "I want to see my pattern across weeks and months."</p>
                <p data-id="element-2057">• "I want to see the loops I keep repeating at work."</p>
                <p data-id="element-2058">
                  • "I want a record of how I actually operate under pressure."
                </p>
                <p data-id="element-2059">• "I want to observe, not just understand."</p>
              </div>
            </div>
          </section>

          {/* 4. MIRRORS VS DECODES */}
          <section className="py-24 px-6 border-t border-[#2B2B2B]" data-id="element-2060">
            <div className="max-w-6xl mx-auto" data-id="element-2061">
              <h2 className="text-3xl md:text-4xl font-serif text-[#F5F5F5] mb-16 text-center" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-2062">
                Mirrors and Decodes
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12" data-id="element-2063">
                <div className="space-y-6" data-id="element-2064">
                  <h3 className="text-xl font-medium text-[#F5F5F5]" data-id="element-2065">
                    Decodes
                  </h3>
                  <div className="space-y-3 text-base text-gray-400" data-id="element-2066">
                    <p data-id="element-2067">• One-time interpretations</p>
                    <p data-id="element-2068">• Good for clarity now</p>
                    <p data-id="element-2069">• Point-in-time view</p>
                    <p data-id="element-2070">• Answer: "What is the structure?"</p>
                  </div>
                </div>

                <div className="space-y-6" data-id="element-2071">
                  <h3 className="text-xl font-medium text-[#F5F5F5]" data-id="element-2072">
                    Mirrors
                  </h3>
                  <div className="space-y-3 text-base text-gray-400" data-id="element-2073">
                    <p data-id="element-2074">• Continuous interpretations</p>
                    <p data-id="element-2075">• Good for long-term observation</p>
                    <p data-id="element-2076">• Time-based view</p>
                    <p data-id="element-2077">• Answer: "How does this structure keep showing up?"</p>
                  </div>
                </div>
              </div>

              <div className="text-center" data-id="element-2078">
                <p className="text-lg text-[#F5F5F5]" data-id="element-2079">
                  Same engine. Different time horizons.
                </p>
              </div>
            </div>
          </section>

          {/* 5. HOW MIRRORS WORK */}
          <section className="py-24 px-6 bg-[#111214] border-t border-[#2B2B2B]" data-id="element-2080">
            <div className="max-w-4xl mx-auto" data-id="element-2081">
              <h2 className="text-3xl md:text-4xl font-serif text-[#F5F5F5] mb-12" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-2082">
                How a Mirror works
              </h2>

              <div className="space-y-12" data-id="element-2083">
                {/* You */}
                <div className="space-y-4" data-id="element-2084">
                  <p className="text-sm font-mono text-gray-600 uppercase tracking-wider" data-id="element-2085">
                    You
                  </p>
                  <div className="space-y-3 text-base text-gray-400" data-id="element-2086">
                    <p data-id="element-2087">• Log situations</p>
                    <p data-id="element-2088">• Log days</p>
                    <p data-id="element-2089">• Log modes</p>
                  </div>
                </div>

                {/* Arrow */}
                <div className="flex justify-center" data-id="element-2090">
                  <div className="text-gray-600 text-2xl" data-id="element-2091">↓</div>
                </div>

                {/* Mirror */}
                <div className="space-y-4" data-id="element-2092">
                  <p className="text-sm font-mono text-gray-600 uppercase tracking-wider" data-id="element-2093">
                    Mirror
                  </p>
                  <p className="text-base text-gray-400" data-id="element-2094">
                    • Continuously interprets these through your underlying
                    pattern
                  </p>
                </div>

                {/* Arrow */}
                <div className="flex justify-center" data-id="element-2095">
                  <div className="text-gray-600 text-2xl" data-id="element-2096">↓</div>
                </div>

                {/* You */}
                <div className="space-y-4" data-id="element-2097">
                  <p className="text-sm font-mono text-gray-600 uppercase tracking-wider" data-id="element-2098">
                    You
                  </p>
                  <div className="space-y-3 text-base text-gray-400" data-id="element-2099">
                    <p data-id="element-2100">• See recurring loops</p>
                    <p data-id="element-2101">• See structural tendencies</p>
                    <p data-id="element-2102">• See what actually repeats</p>
                  </div>
                </div>

                {/* Closing line */}
                <div className="pt-8 border-t border-[#2B2B2B]" data-id="element-2103">
                  <p className="text-sm text-gray-600" data-id="element-2104">
                    This is not journaling. This is pattern recording.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* 6. AVAILABLE MIRRORS */}
          <section className="py-24 px-6 border-t border-[#2B2B2B]" data-id="element-2105">
            <div className="max-w-4xl mx-auto" data-id="element-2106">
              <h2 className="text-3xl md:text-4xl font-serif text-[#F5F5F5] mb-16" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-2107">
                Available Mirrors
              </h2>

              {/* Work Mirror Card */}
              <div className="border border-[#2B2B2B] p-10 space-y-8 bg-[#0A0A0A] mb-8" data-id="element-2108">
                <div className="space-y-4" data-id="element-2109">
                  <h3 className="text-2xl font-medium text-[#F5F5F5]" data-id="element-2110">
                    Work Mirror
                  </h3>
                  <p className="text-base text-gray-400 leading-relaxed" data-id="element-2111">
                    A continuous mirror for how you operate around work,
                    responsibility, decisions, and pressure.
                  </p>
                </div>

                <Link to="/mirrors/work" className="block w-full px-6 py-3 border border-[#F5F5F5] text-[#F5F5F5] text-center text-sm font-medium hover:bg-[#F5F5F5] hover:text-[#0A0A0A] transition-colors" data-id="element-2112">
                  Explore Work Mirror
                </Link>
              </div>

              {/* Future mirrors note */}
              <div className="text-center" data-id="element-2113">
                <p className="text-sm text-gray-600" data-id="element-2114">
                  More mirrors (Life, Relationship, Team) will come later.
                </p>
              </div>
            </div>
          </section>

          {/* 7. WHY THIS EXISTS */}
          <section className="py-24 px-6 bg-[#111214] border-t border-[#2B2B2B]" data-id="element-2115">
            <div className="max-w-4xl mx-auto" data-id="element-2116">
              <h2 className="text-3xl md:text-4xl font-serif text-[#F5F5F5] mb-12" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-2117">
                Why build Mirrors?
              </h2>

              <div className="space-y-8 text-lg text-gray-400 leading-relaxed" data-id="element-2118">
                <p data-id="element-2119">
                  Most patterns don't reveal themselves in a single moment. They
                  reveal themselves through repetition.
                </p>

                <p className="text-[#F5F5F5] pt-6 border-t border-[#2B2B2B]" data-id="element-2120">
                  Mirrors exist to make repetition visible.
                </p>
              </div>
            </div>
          </section>

          {/* 8. FINAL CTA */}
          <section className="py-24 px-6 border-t border-[#2B2B2B]" data-id="element-2121">
            <div className="max-w-4xl mx-auto text-center space-y-12" data-id="element-2122">
              <h2 className="text-3xl md:text-4xl font-serif text-[#F5F5F5]" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-2123">
                Start with the Work Mirror
              </h2>

              <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-2124">
                <Link to="/mirrors/work" className="px-12 py-4 bg-[#F5F5F5] text-[#0A0A0A] text-sm font-medium hover:bg-gray-200 transition-colors" data-id="element-2125">
                  Explore Work Mirror
                </Link>
                <Link to="/decodes" className="px-12 py-4 border border-[#F5F5F5] text-[#F5F5F5] text-sm font-medium hover:bg-[#F5F5F5] hover:text-[#0A0A0A] transition-colors" data-id="element-2126">
                  Explore Decodes
                </Link>
              </div>

              <div data-id="element-2127">
                <Link to="/" className="inline-flex items-center gap-3 text-sm text-gray-600 hover:text-gray-400 transition-colors group" data-id="element-2128">
                  <span data-id="element-2129">Back to Home</span>
                </Link>
              </div>
            </div>
          </section>
        </main>

        {/* Footer */}
        <footer className="py-12 px-6 border-t border-[#2B2B2B]" data-id="element-2130">
          <div className="max-w-6xl mx-auto" data-id="element-2131">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8" data-id="element-2132">
              <div data-id="element-2133">
                <p className="text-sm text-gray-500 font-mono" data-id="element-2134">
                  Lazy Monk Labs
                </p>
                <p className="text-xs text-gray-600 mt-1" data-id="element-2135">
                  Pattern recognition systems
                </p>
              </div>

              <div className="flex gap-8 text-sm text-gray-500" data-id="element-2136">
                <Link to="/decodes" className="hover:text-[#F5F5F5] transition-colors" data-id="element-2137">
                  Decodes
                </Link>
                <Link to="/mirrors/work" className="hover:text-[#F5F5F5] transition-colors" data-id="element-2138">
                  Work Mirror
                </Link>
                <Link to="/decoder" className="hover:text-[#F5F5F5] transition-colors" data-id="element-2139">
                  Decoder
                </Link>
                <Link to="/careers" className="hover:text-[#F5F5F5] transition-colors" data-id="element-2140">
                  Careers
                </Link>
                <a href="https://wa.me/919633096997" target="_blank" rel="noopener noreferrer" className="hover:text-[#F5F5F5] transition-colors" data-id="element-2141">
                  Contact
                </a>
              </div>

              <div className="text-xs text-gray-600 font-mono" data-id="element-2142">
                © {new Date().getFullYear()}
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>;
}